import { render } from "./fb-post-preview.vue?vue&type=template&id=565c5822&scoped=true"
import script from "./fb-post-preview.vue?vue&type=script&lang=js"
export * from "./fb-post-preview.vue?vue&type=script&lang=js"

import "./fb-post-preview.vue?vue&type=style&index=0&id=565c5822&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565c5822"]])

export default __exports__